import { useTheme } from "@mui/material";
import { PropsWithChildren } from "react";

import { Stack } from "../Stack";

const RoundedBorderContainer = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  return (
    <Stack
      border={`1px solid ${theme.palette.section.border}`}
      borderRadius={4}
      marginBottom={3}
      marginTop={2}
      padding={4}
      paddingY={3}
    >
      {children}
    </Stack>
  );
};

export default RoundedBorderContainer;
